import pluralize from 'pluralize';
import React from 'react';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { centsToDollars } from '@mm/utils';
import BasicModalTemplate from '../../../../../common/modals/BasicModalTemplate';
import { ModalInstanceProps } from '../../../../../common/modals/interfaces';
import { ConfirmManagePagesModalParams } from '@mm/state/modules/modalsState/actions';
import './ConfirmManagePagesModal.pcss';

type Props = ConfirmManagePagesModalParams & ModalInstanceProps;

const ConfirmManagePagesModal = (props: Props) => {
  const { subscription, closeModal, pagesCount } = props;
  const discount = pagesCount * (subscription.extraPageAddOnPrice || 1500);

  return (
    <BasicModalTemplate
      className="confirm-manage-pages-modal"
      withMonkeyBackground={false}
      iconClass="confirm-manage-pages-modal__close-icon"
    >
      <div className="confirm-manage-pages-modal__body">
        <div className="confirm-manage-pages-modal__header-text">
          <i className="fas fa-check-circle confirm-manage-pages-modal__check" />
          <p className="confirm-manage-pages-modal__header-text-heading">
            All Set!
          </p>
        </div>
        <div className="confirm-manage-pages-modal__note">
          You have successfully disabled {pagesCount} page{' '}
          {pluralize('slot', pagesCount)} from your subscription, effective
          immediately. You will receive <b>${centsToDollars(discount)}</b> as a
          credit for {pagesCount === 1 ? 'this page' : 'these pages'} in your
          next bill.
        </div>
        <div className="confirm-manage-pages-modal__buttons">
          <PrimaryButton
            onClick={() => closeModal()}
            className="confirm-manage-pages-modal__confirm-button"
          >
            Confirm Changes
          </PrimaryButton>
        </div>
      </div>
    </BasicModalTemplate>
  );
};

export default ConfirmManagePagesModal;
